module.exports = __webpack_public_path__ + "static/media/quarteto_coliseu_5.73de42a7.jpg";